export default "__VITE_ASSET__BuV_3oOY__"